module.exports = __webpack_public_path__ + "img/full0-min.734e6a6f.png";